import { apiV1 } from './api';

export const postMissionProposal = data =>
  apiV1.post('/mission_proposals', { missionProposal: data });

export const postContactProposal = data =>
  apiV1.post('/contact_proposals', { contactProposal: data });
